export const COLOR_PALETTE = {
  shcSeries: {
    average: "--color_5",
    you: "--color_1",
    efficient: "--color_13"
  }
};
